var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSulphurDioxide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8044 23.3438L27.8005 25.4531H8.49974L7.192 23.3438L13.2247 14.4632V4.21875H11.1154V0H25.881V4.21875H23.7716V14.4632L29.8044 23.3438Z",
    fill: "#D6D7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8044 23.3438L27.8004 25.4531H18.4982V0H25.881V4.21875H23.7716V14.4632L29.8044 23.3438Z",
    fill: "#BCBDC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5465 27.4359L29.8044 23.3438H7.192L4.51302 27.3515C3.18411 28.9335 2.88873 31.0852 3.77481 32.9625C4.63958 34.8398 6.47474 36 8.542 36H28.4544C30.5216 36 32.3568 34.8398 33.2215 32.9625C34.1076 31.0851 33.8122 28.9335 32.5465 27.4359Z",
    fill: "#BAECB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2216 32.9625C32.3568 34.8398 30.5217 36 28.4544 36H18.4982V23.3438H29.8044L32.5466 27.4359C33.8122 28.9335 34.1076 31.0851 33.2216 32.9625Z",
    fill: "#8BB982"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1154 29.6719H9.00598V31.7812H11.1154V29.6719Z",
    fill: "#608659"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5529 29.6719H17.4435V31.7812H19.5529V29.6719Z",
    fill: "#608659"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3341 27.5625H13.2247V29.6719H15.3341V27.5625Z",
    fill: "#608659"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4435 19.125H15.3341V21.2344H17.4435V19.125Z",
    fill: "#BCBDC1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5529 14.9062H17.4435V17.0156H19.5529V14.9062Z",
    fill: "#BCBDC1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5529 8.50781H17.4435V10.6172H19.5529V8.50781Z",
    fill: "#BCBDC1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5529 8.50781H18.4982V10.6172H19.5529V8.50781Z",
    fill: "#8B8C93"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5529 14.9062H18.4982V17.0156H19.5529V14.9062Z",
    fill: "#8B8C93"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5529 29.6719H18.4982V31.7812H19.5529V29.6719Z",
    fill: "#395334"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSulphurDioxide);
export default __webpack_public_path__ + "static/media/sulphur-dioxide.ff54d52e24ff3d8cb27ffda1e9f4ef4e.svg";
export { ForwardRef as ReactComponent };